import { OnDestroy } from '@angular/core/src/metadata/lifecycle_hooks';
import { Component, OnInit, ViewEncapsulation, ViewChild, Input, OnChanges } from '@angular/core';
import { MatTableDataSource, MatSort } from '@angular/material';
import { Record } from './../models/record';
import { AppEventDispatcher } from '../../../utils/AppEventDispatcher';
import { EventTypes } from '../../../shared/EventTypes';
import { Cookie } from 'ng2-cookies/ng2-cookies';
import { Auth } from '../../../autentication/Auth';
import CryptoJS from 'crypto-js';
import { OperationType } from '../../pix/models/transaction.model';


@Component({
	selector: 'app-extract-table',
	templateUrl: './extract-table.component.html',
	styleUrls: ['./extract-table.component.styl'],
	encapsulation: ViewEncapsulation.None
})
export class ExtractTableComponent implements OnChanges {
	@Input() records: Array<Record> = [];
	@Input() noRecordsMessage = 'Não há registros.';
	@Input() isLoading: boolean;

	public dataSource: MatTableDataSource<Record>;
	public displayedColumns: Array<string> = ['date', 'history', 'value'];
	public haventRegisters = true;
	public toggleBalance: boolean;
	public showExtractTable: boolean;
	public operationType = OperationType;



	public user = Auth.getInstance().getUser().cpf;

	constructor() {
		const userCpf = CryptoJS.MD5(this.user).toString();
		const cookie = JSON.parse(Cookie.get('OmniToggleBalance' + userCpf));
		this.dataSource = new MatTableDataSource(this.records);
		this.toggleBalance = cookie !== null ? cookie : true;
		AppEventDispatcher.listen(EventTypes.EXTRACT_TABLE_TOGGLE_BALANCE, data => {
			this.toggleBalance = data.show;
		});

	}

	ngOnChanges() {
		this.dataSource = new MatTableDataSource(this.records);
	}

	isGroup(index, item): boolean {
		return item.name === 'saldo do dia';
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/extract/extract-table/extract-table.component.ts